import React from 'react'
import { Modal, Backdrop, Fade, TextField, Button, Grid } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import Audio from '../Audio'
import libraryIcon from '../../../../../../../assetss/img/libraryIcon.svg'
import { useStyles } from './style'

const ModalPodcast = ({ open, deleteImgPodcast, uploadHandlerAudio, podcast, audioRef, audioElement, audioProps, deleteAudio, handleAudioChange, uploadAudio, uploadImgsStorys, onChangeValue, podcastSrc, createPodcast, handleClose }) => {
  const classes = useStyles()
  const defaultInput = e => e?.preventDefault()

  return (
    <div>
      <Modal
        aria-labelledby='transition-modal-title'
        aria-describedby='transition-modal-description'
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            {podcastSrc?.imgSrc ? (
              <>
                <img className={classes.imgPodcast} src={podcastSrc?.imgSrc} />
                <div className={classes.deleteImgIcon}><DeleteIcon className={classes.iconDelete} onClick={deleteImgPodcast} /></div>
              </>
            ) : (
              <>
                <input
                  accept='image/*'
                  id='contained-button-file'
                  type='file'
                  className={classes.customUpload}
                  onChange={e => handleAudioChange(e, uploadImgsStorys)}
                />
                <label htmlFor='contained-button-file'>
                  <div className={classes.imgBox} component='span'>
                    <img className={classes.imgDefault} src={libraryIcon} />
                    <div className={classes.textUpload}>
                      Tap here or drag & drop to upload an image
                    </div>
                  </div>
                </label>
              </>
            )}
            <TextField
              className={classes.input}
              value={podcast?.name}
              variant='filled'
              onChange={e => onChangeValue('name')(e?.target?.value)}
              name='name'
              placeholder='Title'
              autoComplete='off'
            />
            <TextField
              className={classes.inputTag}
              variant='filled'
              onChange={e => onChangeValue('tags')(e?.target?.value)}
              name='Tags'
              placeholder='Hashtags'
              autoComplete='off'
              value={podcast?.tags}
            />
            <TextField
              className={classes.inputTag}
              variant='filled'
              onChange={e => onChangeValue('listenCountDefault')(e?.target?.value)}
              name='Like'
              placeholder='Number of plays'
              autoComplete='off'
              value={podcast?.listenCountDefault}
              type='number'
            />
            {podcastSrc?.audioSrc ? (
              <Grid className={classes.audioBox}>
                <Audio audioElement={audioElement} audioProps={audioProps} />
                <DeleteIcon className={classes.iconDelete} onClick={deleteAudio} />
              </Grid>
            ) : (
              <>
                <Button onClick={uploadHandlerAudio} className={classes.btnUpload}>UPLOAD AUDIO</Button>
                <input
                  onChange={e => {
                    handleAudioChange(e, uploadAudio)
                    defaultInput(e)
                  }}
                  className={classes.uploadAudio} type='file' ref={audioRef}
                  accept='.mp3, .ogg'
                />
              </>
            )}
            <Grid className={classes.boxBtnFooter}>
              <Button
                className={classes.close}
                onClick={handleClose}
              >
                CLOSE
              </Button>
              <Button className={classes.save} onClick={() => createPodcast(audioProps.duration)}>SAVE</Button>
            </Grid>
          </div>
        </Fade>
      </Modal>
    </div>
  )
}

export default ModalPodcast
